import type { Response } from '~/types/api/v2'

import type { WorkspaceIdentifier } from '../types'

import { useFetchWithDefaults } from '../useFetchWithDefaults'

// TODO: replace with backend API type
export interface SigningSettings {
  default_contract_expiration_duration?: string
  __data_type: 'general_signing_settings_data'
}

export const responseDataTypeName: SigningSettings['__data_type'] = 'general_signing_settings_data'

export const useFetchSigningSettings = () => {
  const { get: getRequest } = useFetchWithDefaults()

  const get = ({ workspaceId }: WorkspaceIdentifier) => getRequest<Response<SigningSettings>>({
    url: '/v2/settings/signing',
    workspaceId,
  })

  return {
    get,
  }
}
